﻿(function (angular, innerHeight, ToyotaConsts) {
  "use strict";

  var SMOOTH_SCROLL_DURATION_MS = 500;

  angular.module("Toyota.Directives").directive("tySecondaryNav", [
    "$window",
    "Location",
    "CssMediaWatcher",
    "InfoService",
    "$timeout",
    "StickToTopManager",
    "DealerSelector",
    "cookies",
    function (
      $window,
      Location,
      CssMediaWatcher,
      InfoService,
      $timeout,
      StickToTopManager,
      DealerSelector,
      cookies
    ) {
      var ANIMATE_SPEED = 800;

      var controller = [
        "$scope",
        "$rootScope",
        function ($scope, $rootScope) {
          $scope.showLocationOverlay = function () {
            DealerSelector.openDealerSelector();
          };
        },
      ];

      return {
        scope: false,
        restrict: "A",
        bindToController: true,
        controller: controller,
        link: function (scope, element, attrs) {
          var GLOBAL_NAV_ID_HASH = "#toyota-main-navigation";

          scope.suburb = Location.get().suburb;
          scope.attrs = attrs;

          var SAVED_CAR_COOKIE_KEY = "retailWatchlist";
          var numberOfSavedCars = 0;

          if (cookies.exists(SAVED_CAR_COOKIE_KEY)) {
            numberOfSavedCars = cookies.get(SAVED_CAR_COOKIE_KEY).split(",").length;
          }

          scope.savedCars = numberOfSavedCars;

          scope.$on("GeoPostCode", function (event, postcode, suburb) {
            scope.suburb = suburb;
          });

          var $body = angular.element("body");
          var $clipContainer = element;
          var $navbarContainer = element.find(".js-ty-secondary-nav-wrapper");
          var $dropdown = element.find(".js-ty-secondary-nav-dropdown");

          var phases = {
            ANIMATING_OPEN: "animatingOpen",
            FULLY_OPENED: "open",
            ANIMATING_CLOSED: "animatingClosed",
            FULLY_CLOSED: "closed",
          };

          var state = {
            phase: phases.FULLY_CLOSED,
            bodyScrollingFrozen: null,
            metrics: null,
            frozenScrollTop: null,
          };

          var oldState = {
            phase: null,
            bodyScrollingFrozen: null,
            metrics: null,
            frozenScrollTop: null,
          };

          var actions = {
            REFRESH_SIZE: "refreshSize",
            STORE_FROZEN_SCROLL_TOP: "storeFrozenScrollTop",
            TOGGLE: "toggle",
            ANIMATE_TO_OPEN: "animateToOpen",
            OPEN_IMMEDIATELY: "openImmediately",
            ANIMATE_TO_CLOSED: "animateToClosed",
            CLOSE_IMMEDIATELY: "closeImmediately",
          };

          function getMetrics() {
            var windowHeight = innerHeight;
            var navbarViewportTop = $navbarContainer.get(0).getBoundingClientRect().top;
            var navbarHeight = $navbarContainer.height();
            return {
              navbarViewportTop: navbarViewportTop,
              navbarScrollTop: navbarViewportTop + $body.scrollTop(),
              navbarHeight: navbarHeight,
              dropdownHeight: windowHeight - navbarHeight - navbarViewportTop,
              totalHeight: windowHeight,
            };
          }

          InfoService.registerInfo(ToyotaConsts.InfoKeys.SecondaryNavMetrics, getMetrics());

          function setDropdownBorder(show) {
            $dropdown.css("border-top-width", show ? "1px" : "0");
          }

          function setDropdownHeightOpen(open, metrics) {
            $dropdown.css("height", open ? metrics.dropdownHeight : "");
          }

          function animateClipHeightOpen(metrics, doneCallback) {
            $clipContainer.animate(
              {
                height: metrics.totalHeight,
              },
              {
                duration: ANIMATE_SPEED,
                easing: "easeInOutExpo",
                complete: function () {
                  if (doneCallback) {
                    doneCallback();
                  }
                },
              }
            );
          }

          function animateClipHeightClosed(metrics, doneCallback) {
            $clipContainer.animate(
              {
                height: metrics.navbarHeight,
              },
              {
                duration: ANIMATE_SPEED,
                easing: "easeInOutExpo",
                complete: function () {
                  if (doneCallback) {
                    doneCallback();
                  }
                },
              }
            );
          }

          function smoothScrollTo(position) {
            angular.element("body").animate(
              {
                scrollTop: position,
              },
              SMOOTH_SCROLL_DURATION_MS
            );
          }

          function freezeVp(e) {
            e.preventDefault();
          }

          function setBodyScrollingFrozen(frozen) {
            if (frozen) {
              $body.css("overflow", "hidden");
              angular.element(document).on("touchmove", freezeVp); // For iOS
            } else {
              $body.css("overflow", "");
              angular.element(document).off("touchmove", freezeVp); // For iOS
            }
          }

          function setClipHeightOpen(open, metrics) {
            $clipContainer.css("height", open ? metrics.totalHeight : metrics.navbarHeight);
          }

          function repaint() {
            var isPhaseChanged = oldState.phase !== state.phase;
            var isMetricsChanged = JSON.stringify(oldState.metrics) !== JSON.stringify(state.metrics);

            if (
              isPhaseChanged ||
              (isMetricsChanged && state.phase === phases.FULLY_OPENED) ||
              (isMetricsChanged && state.phase === phases.FULLY_CLOSED)
            ) {
              if (state.phase === phases.FULLY_CLOSED) {
                setDropdownHeightOpen(false, state.metrics);
                setClipHeightOpen(false, state.metrics);
              }

              if (state.phase === phases.ANIMATING_OPEN) {
                smoothScrollTo(getMetrics().navbarScrollTop);
                setDropdownHeightOpen(true, state.metrics);
                animateClipHeightOpen(state.metrics, function () {
                  dispatch(actions.OPEN_IMMEDIATELY);
                });
              }

              if (state.phase === phases.FULLY_OPENED) {
                $body.scrollTop(getMetrics().navbarScrollTop);
                setDropdownHeightOpen(true, state.metrics);
                setClipHeightOpen(true, state.metrics);
              }

              if (state.phase === phases.ANIMATING_CLOSED) {
                animateClipHeightClosed(state.metrics, function () {
                  dispatch(actions.CLOSE_IMMEDIATELY);
                });
              }

              // repaint icon
              scope.isDropdownActive = state.phase === phases.ANIMATING_OPEN || state.phase === phases.FULLY_OPENED;
            }

            if (state.bodyScrollingFrozen !== oldState.bodyScrollingFrozen) {
              if (state.bodyScrollingFrozen) {
                dispatch(actions.STORE_FROZEN_SCROLL_TOP);
              }

              setBodyScrollingFrozen(state.bodyScrollingFrozen);
            }

            setDropdownBorder(state.phase !== phases.FULLY_CLOSED);

            oldState = $.extend(true, {}, state);

            scope.$broadcast("secondary-nav-repaint");
          }

          function dispatch(action) {
            var actionsRequiringMetricsRefresh = [
              actions.REFRESH_SIZE,
              actions.ANIMATE_TO_OPEN,
              actions.OPEN_IMMEDIATELY,
              actions.ANIMATE_TO_CLOSED,
              actions.CLOSE_IMMEDIATELY,
            ];

            if (actionsRequiringMetricsRefresh.indexOf(action) !== -1) {
              state.metrics = getMetrics();
            }

            if (action === actions.STORE_FROZEN_SCROLL_TOP) {
              state.frozenScrollTop = $body.scrollTop();
            }

            if (action === actions.REFRESH_SIZE) {
              repaint();
            }

            if (action === actions.TOGGLE) {
              if (state.phase === phases.FULLY_CLOSED) {
                dispatch(actions.ANIMATE_TO_OPEN);
              } else if (state.phase === phases.FULLY_OPENED) {
                dispatch(actions.ANIMATE_TO_CLOSED);
              }
            }

            if (action === actions.ANIMATE_TO_OPEN) {
              if (state.phase !== phases.ANIMATING_OPEN && state.phase !== phases.ANIMATING_CLOSED) {
                state.bodyScrollingFrozen = true;
                state.phase = phases.ANIMATING_OPEN;
                repaint();
              }
            }

            if (action === actions.OPEN_IMMEDIATELY) {
              state.bodyScrollingFrozen = true;
              state.phase = phases.FULLY_OPENED;
              repaint();
            }

            if (action === actions.ANIMATE_TO_CLOSED) {
              if (state.phase !== phases.ANIMATING_OPEN && state.phase !== phases.ANIMATING_CLOSED) {
                state.bodyScrollingFrozen = true;
                state.phase = phases.ANIMATING_CLOSED;
                repaint();
              }
            }

            if (action === actions.CLOSE_IMMEDIATELY) {
              state.bodyScrollingFrozen = false;
              state.phase = phases.FULLY_CLOSED;
              repaint();
            }
          }

          // Hook on Global Nav Hide
          function isGlobalNavOpened() {
            return angular.element(GLOBAL_NAV_ID_HASH).hasClass("in");
          }

          function collapseGlobalNav() {
            if (angular.element(GLOBAL_NAV_ID_HASH).collapse) {
              angular.element(GLOBAL_NAV_ID_HASH).collapse("hide");
            }
          }

          function onGlobalNavHidden(action) {
            angular.element(GLOBAL_NAV_ID_HASH).on("hidden.bs.collapse", function () {
              dispatch(action);
              angular.element(GLOBAL_NAV_ID_HASH).off("hidden.bs.collapse");
            });
          }

          function checkGlobalNavStateAndHide() {
            onGlobalNavHidden(actions.TOGGLE);
            collapseGlobalNav();
          }

          // Hook on Show Global Nav
          function onGlobalNavigationShow() {
            angular.element(GLOBAL_NAV_ID_HASH).on("shown.bs.collapse", function () {
              dispatch(actions.CLOSE_IMMEDIATELY);
            });
          }

          onGlobalNavigationShow();

          scope.showHideMenu = function () {
            if (isGlobalNavOpened()) {
              checkGlobalNavStateAndHide();
              return;
            }

            dispatch(actions.TOGGLE);
          };

          scope.closeMenuImmediately = function () {
            dispatch(actions.CLOSE_IMMEDIATELY);
          };

          angular.element($window).on("resize", function () {
            dispatch(actions.REFRESH_SIZE);
          });

          scope.$on("will-modal-close", function () {
            $timeout(function () {
              dispatch(actions.REFRESH_SIZE);
            }, 0);
          });

          CssMediaWatcher({
            $el: element,
            pseudoEl: "before",
            mediaProperty: "viewportWidth",
            mediaRegexes: {
              mobile: "^mobile$",
              desktop: "^desktop$",
            },
          }).on("didInitOrChange", function (e, cssMedia) {
            if (cssMedia.viewportWidth.is.desktop) {
              dispatch(actions.CLOSE_IMMEDIATELY);
            } else {
              dispatch(actions.REFRESH_SIZE);
            }
          });
        },
      };
    },
  ]);
})(window.angular, window.innerHeight, window.ToyotaConsts);
